import { useState } from "react";
import Markdown from "@/components/Markdown";
import LegalModal from "@/components/LegalModal";
import SocialStrip from "@/components/SocialStrip";
import { useSiteSettings } from "@/context/SiteSettingsContext";
import { Wrench } from "lucide-react";

export default function MaintenanceScreen({ message }) {
  const { settings } = useSiteSettings();
  const [modal, setModal] = useState(null);
  return (
    <div className="min-h-screen flex flex-col bg-[#0B0F19]" data-testid="maintenance-screen">
      <div className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="max-w-xl w-full text-center">
          <Wrench className="w-12 h-12 mx-auto text-[#00E5FF]" />
          <div className="h-1 w-12 bg-[#00E5FF] mx-auto mt-6" />
          <div className="eyebrow text-[#00E5FF] mt-3">Wartung</div>
          <h1 className="font-display font-black italic uppercase tracking-normal text-5xl sm:text-6xl leading-none mt-2">
            Wir basteln
          </h1>
          <div className="mt-8 text-neutral-300 text-left">
            {message ? <Markdown>{message}</Markdown> : (
              <p className="text-center text-neutral-400">
                Die Seite ist gerade nicht verfügbar. Schau in Kürze noch einmal vorbei.
              </p>
            )}
          </div>
        </div>
      </div>
      <footer className="border-t border-white/5 py-6 bg-[#0B0F19]/80" data-testid="maintenance-footer">
        <div className="max-w-3xl mx-auto px-6 flex items-center justify-between text-xs text-neutral-500 gap-4 flex-wrap">
          <span>© {new Date().getFullYear()} Sector Four</span>
          <SocialStrip settings={settings} />
          <div className="flex items-center gap-4">
            <button
              type="button"
              onClick={() => setModal("impressum")}
              className="hover:text-cyan-300 cursor-pointer"
              data-testid="maintenance-impressum"
            >Impressum</button>
            <button
              type="button"
              onClick={() => setModal("datenschutz")}
              className="hover:text-cyan-300 cursor-pointer"
              data-testid="maintenance-datenschutz"
            >Datenschutz</button>
          </div>
        </div>
      </footer>
      <LegalModal field={modal || "impressum"} open={!!modal} onClose={() => setModal(null)} />
    </div>
  );
}
